import { getVariant, createVariant, updateVariant, queryVariants, bulkCreateVariants, deleteVariant, bulkDeleteVariants, countVariants } from '@wix/ambassador-restaurants-menus-v1-item-variant/http';
import { MAX_NUMBER_OF_PRICE_VARIANTS_FROM_SERVER, getEntityChunks, orderEntitiesById, BULK_DELETE_CHUNK_SIZE, callInChunks } from './utils';
import { ErrorTypes } from '../types/api';
import { BaseAPIClient } from './BaseAPIClient';
export class VariantsClient extends BaseAPIClient {
  async getById(variantId) {
    const response = await this.request(getVariant, {
      variantId
    });
    return response.data.variant;
  }
  async getBulk(args) {
    var _args$ids;
    let idChunks;
    let variants = [];
    let pagingMetadata;
    if (args != null && (_args$ids = args.ids) != null && _args$ids.length) {
      idChunks = getEntityChunks(args == null ? void 0 : args.ids, MAX_NUMBER_OF_PRICE_VARIANTS_FROM_SERVER);
      const variantsInChunks = await Promise.all(idChunks.map(async chunk => {
        const query = {
          filter: {
            id: {
              $in: chunk || []
            }
          }
        };
        const {
          data
        } = await this.request(queryVariants, {
          query
        });
        return data.variants || [];
      }));
      variants.push(...variantsInChunks.flatMap(variant => variant));
      const variantsByClientOrder = orderEntitiesById(args.ids, variants);
      variants = variantsByClientOrder;
    } else {
      const {
        data
      } = await this.request(queryVariants, {
        query: {
          cursorPaging: args == null ? void 0 : args.paging
        }
      });
      variants = data.variants;
      pagingMetadata = data.pagingMetadata;
    }
    return {
      data: variants,
      pagingMetadata
    };
  }
  async create(variant) {
    const response = await this.request(createVariant, {
      variant
    });
    return response.data.variant;
  }
  async update(variant) {
    const response = await this.request(updateVariant, {
      variant
    });
    return response.data.variant;
  }
  async query(query) {
    const response = await this.request(queryVariants, {
      query
    });
    return {
      data: response.data.variants,
      pagingMetadata: response.data.pagingMetadata
    };
  }
  async bulkCreate(variants) {
    const response = await this.request(bulkCreateVariants, {
      variants,
      returnEntity: true
    });
    const results = response.data.results || [];
    return results.map(result => result.variant);
  }
  async delete(variantId) {
    const response = await this.request(deleteVariant, {
      variantId
    });
    return response.data;
  }
  async bulkDelete(variantIds) {
    var _response$bulkActionM;
    const response = await callInChunks(chunkVariantIds => this.request(bulkDeleteVariants, {
      ids: chunkVariantIds
    }), variantIds, BULK_DELETE_CHUNK_SIZE);
    if ((_response$bulkActionM = response.bulkActionMetadata) != null && _response$bulkActionM.totalFailures) {
      var _response$results;
      const errors = ((_response$results = response.results) == null ? void 0 : _response$results.filter(result => {
        var _result$itemMetadata;
        return (_result$itemMetadata = result.itemMetadata) == null ? void 0 : _result$itemMetadata.error;
      })) || [];
      const errorMessage = {
        name: ErrorTypes.BULK_DELETE_VARIANTS,
        message: errors.map(result => {
          var _result$itemMetadata2;
          return (_result$itemMetadata2 = result.itemMetadata) == null ? void 0 : _result$itemMetadata2.error;
        }).join(', ')
      };
      throw new Error('Failed to delete variants', {
        cause: errorMessage
      });
    }
    return {};
  }
  async countVariants(filter) {
    const response = await this.request(countVariants, {
      filter
    });
    return response.data.count;
  }
}
//# sourceMappingURL=VariantsClient.js.map